module.exports = "<div fxLayout=\"column\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n    <img src=\"./assets/img/loading.gif\"/>\r\n    <span class=\"texto\">{{data}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/loading/loading.component.html
// module id = ../../../../../src/app/components/loading/loading.component.html
// module chunks = main